import { Environment } from '@global/infrastructure/models/environment';
import {EnvironmentProviderConfig} from './environment-provider.config';

const urlParams = new URLSearchParams(window.location.search);
const enableMocks = urlParams.get('enableMocks') === 'true';

export const EnvironmentServiceFactory = () => {
  const envSetting: Environment = EnvironmentProviderConfig.generateConfig(enableMocks)
  return envSetting;
};

export const getEnvironmentProviders = {
    provide: Environment,
    useFactory: EnvironmentServiceFactory,
};
